<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('daily_course_schedules_calendar')" :is-filter="false" />
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('daily_course_schedules_calendar')" :is-filter="false" />
            </template>
            <vue-cal
                :events="events"
                :active-view="activeView"
                :disable-views="['years', 'year']"
                :time-step="60"
                events-on-month-view
                @view-change="onViewChange"
                class="custom-vuecal"
                :on-event-click="showVueCalModal"
                :cell-height="cellHeight"
            >
                <template #event="{ event }">
                    <div
                        class="vuecal__event-title border"
                        :style="{ backgroundColor: event.color, color: '#fff' }"
                        v-html="event.title"
                    ></div>
                    <div class="vuecal__event-content">
                        <div class="event-time">
                            <strong>{{ $t('start_time') }}</strong>: {{ event.start_time }}<br />
                            <strong>{{ $t('end_time') }}</strong>: {{ event.end_time }}<br />
                            <strong>{{ $t('classroom') }}</strong>: {{ event.classroom_name ?? '-' }}<br />
                            <strong>{{ $t('instructor') }}</strong>: {{ event.instructor ?? '-' }}
                        </div>
                    </div>
                </template>
            </vue-cal>
        </app-layout>
        <CommonModal ref="AddModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear">
            <template v-slot:CommonModalTitle>
                <div>{{ $t('detail') }}</div>
            </template>
            <template v-slot:CommonModalContent>
                <div>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group :label="$t('course_code')">
                                <div class="label-as-input">{{ form.course_code || '-' }}</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group :label="$t('course_name')">
                                <div class="label-as-input">{{ form.course_name || '-' }}</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group :label="$t('classroom')">
                                <div class="label-as-input">{{ form.classroom_name || '-' }}</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group :label="$t('instructor')">
                                <div class="label-as-input">{{ form.instructor || '-' }}</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group :label="$t('start_time')">
                                <div class="label-as-input">{{ form.start_time || '-' }}</div>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group :label="$t('end_time')">
                                <div class="label-as-input">{{ form.end_time || '-' }}</div>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </div>
            </template>
        </CommonModal>
    </div>
</template>

<script>
import AppLayout from '@/layouts/AppLayout';
import Header from '@/layouts/AppLayout/Header';
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile';
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import '/src/locales/en/vuecal.js';
import moment from 'moment';
import qs from 'qs';
import DailyCourseScheduleCalendarService from '@/services/DailyCourseScheduleCalendarService';

export default {
    components: {
        AppLayout,
        Header,
        VueCal,
        HeaderMobile,
    },
    metaInfo() {
        return {
            title: this.$t('daily_course_schedules_calendar'),
        };
    },
    data() {
        return {
            eventId: null,
            events: [],
            cellHeight: 500,
            activeView: 'month',
            loading: false,
            startDate: null,
            filter: {
            },
            form: {
                course_name:null,
                course_code:null,
                classroom_name:null,
                instructor:null,
                start_time:null,
                end_time:null,
            },
            currentMonth: null,
            currentYear: null,
        };
    },
    computed: {
        selectedDate() {
            const date = this.filter.by_month?.split(',');
            if (date) {
                return `${date[1]}-${date[0]}-01`;
            }
            return '';
        },
    },
    mounted() {
        this.dateFormat();
    },
    methods: {
        dateFormat() {
            const currentDate = new Date();
            const year = currentDate.getFullYear();
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            this.filter.month = Number(month)
            this.filter.year = year
            this.getRows();
        },
        getRandomColor(event) {
            //return event.course_code?.startsWith('COMM') ? '#F02121' : '#00FF00';
            return '#747474';
        },
        onViewChange({ startDate, view }) {
            this.activeView = view;
            if (view === 'month' || view === 'week') {
                this.setCurrentMonthAndYear(startDate);
            }
            this.cellHeight = view === 'week' ? 800 : 500;
        },
        setCurrentMonthAndYear(startDate) {
            if (!(startDate instanceof Date) || isNaN(startDate)) {
                return;
            }
            this.currentMonth = startDate.getMonth() + 1;
            this.currentYear = startDate.getFullYear();
            this.filter.month =this.currentMonth
            this.filter.year = this.currentYear
            this.getRows();
        },
        getRows() {
            const config = {
                params: {
                    filter: { ...this.filter },
                    limit: -1,
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };

            this.loading = true;
            return DailyCourseScheduleCalendarService.getCalendar(config)
                .then((response) => {
                    const data = response.data.data || [];
                    this.events = data
                        .filter((event) => event.date && event.start_time && event.end_time)
                        .map((event) => {
                            const startDateTime = moment(`${event.date} ${event.start_time}`, 'YYYY-MM-DD HH:mm');
                            const endDateTime = moment(`${event.date} ${event.end_time}`, 'YYYY-MM-DD HH:mm');

                            if (!startDateTime.isValid() || !endDateTime.isValid()) {
                                return null;
                            }

                            return {
                                id: event.id || Math.random().toString(36).substr(2, 9),
                                title: event.course_code,
                                start: startDateTime.toDate(),
                                end: endDateTime.toDate(),
                                start_time: startDateTime.format('HH:mm'),
                                end_time: endDateTime.format('HH:mm'),
                                classroom_name: event.classroom || '-',
                                instructor: event.instructor || '-',
                                course_code: event.course_code || '-',
                                course_name: event.course_name || '-',
                                color: this.getRandomColor(event),
                            };
                        })
                        .filter((event) => event !== null)
                        .sort((a, b) => a.start - b.start);
                })
                .catch((error) => {
                    this.showErrors(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        showVueCalModal(event, e) {
            this.eventId = event.id;
            this.form = {
                course_name: event.course_name || null,
                course_code: event.course_code || null,
                classroom_name: event.classroom_name || null,
                instructor: event.instructor || null,
                start_time: event.start_time || null,
                end_time: event.end_time || null,

            };
            this.$refs.AddModal?.$refs.commonModal.show();
        },
        formClear() {
            this.eventId = null;
            this.$refs.AddModal?.$refs.commonModal.hide();
            this.form = {
                course_name:null,
                course_code:null,
                classroom_name:null,
                instructor:null,
                start_time:null,
                end_time:null,
            };
        },
    },
};
</script>

<style>
.vuecal__cell {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100px;
    height: auto;
    transition: 0.15s ease-in-out background-color;
}

.vuecal--week-view .vuecal__cell {
    min-height: 150px;
}

.vuecal__event {
    width: 100%;
    padding: 4px;
    box-sizing: border-box;
}

.vuecal__event-title {
    font-size: 12px;
    padding: 2px;
    line-height: 1.2;
}

.vuecal__event-content {
    font-size: 10px;
    line-height: 1.3;
    overflow: visible;
}

.vuecal__event-content .event-time {
    text-align: left;
    white-space: nowrap;
}
</style>
